<template>
  <iframe
    class="adl-ad"
    v-if="hasLoaded && user && data"
    :src="data.ad_url"
    :width="data.width"
    :height="data.height"
  ></iframe>
</template>

<script>
import store from "../../store";
import { mapGetters } from "vuex";
import axios from "axios";
import { sha256 } from "../../../functions/general-functions";
export default {
  watch: {
    hasLoaded: function (newValue, oldValue) {
      if (newValue && this.user) {
        this.getAd();
      }
    },
  },
  computed: {
    ...mapGetters("auth", {
      user: "user",
      hasLoaded: "hasLoaded",
    }),
  },

  methods: {
    getAd: async function () {
      if (!this.loaded) {
        this.loaded = true;
        const hash = await sha256(this.user.email);
        axios.get(`https://adl.lalr.co/api/get-ad/${hash}`).then((q) => {
          if (q.data.success) {
            this.data = q.data;
          }
        });
      }
    },
  },
  data: function () {
    return {
      loaded: false,
      data: null,
    };
  },
};
</script>
